// extracted by mini-css-extract-plugin
export default {"createSpaceDialog":"CreateSpaceDialog-module__createSpaceDialog--yuVoo","textAreaWrapper":"CreateSpaceDialog-module__textAreaWrapper--sSv2f"};